import React, { useEffect } from 'react';
import { CountdownProvider } from './contexts/CountdownContext';
import { initMetaPixel, META_PIXEL_ID } from './utils/metaPixel';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Hero } from './components/Hero';
import { ProblemSolution } from './components/ProblemSolution';
import { SkillsSection } from './components/SkillsSection';
import { PriceBlock } from './components/PriceBlock';
import { ProjectsShowcase } from './components/ProjectsShowcase';
import { MaterialsMarquee } from './components/MaterialsMarquee';
import { DevelopmentSection } from './components/DevelopmentSection';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { StickyBuyBar } from './components/StickyBuyBar';
import { PurchaseToast } from './components/PurchaseToast';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <CountdownProvider data-id="element-0" data-mp="3ikr0s4yore8d">
      <noscript data-id="element-1" data-mp="3ij61y35c994p">
        <img height="1" width="1" style={{
        display: 'none'
      }} alt="" src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-2" data-mp="3ijpdn24eb1aa" />
      </noscript>
      <div className="min-h-screen w-full bg-white font-body text-ink" data-id="element-3" data-mp="5yjetptzbev">
        <AnnouncementBar data-id="element-4" data-mp="56l3b4umzkw" />
        <Hero data-id="element-5" data-mp="2zl3bdjx5744s" />
        <main data-id="element-6" data-mp="2zllff2q1qmn9">
          <ProblemSolution data-id="element-7" data-mp="2zlv3gkrj6jqb" />
          <SkillsSection data-id="element-8" data-mp="2zmo7vf30ox5a" />
          <PriceBlock data-id="element-9" data-mp="2zng2amkvootz" />
          <ProjectsShowcase data-id="element-10" data-mp="33m5b01uz1i7a" />
          <MaterialsMarquee data-id="element-11" data-mp="33ngdzzglelxc" />
          <DevelopmentSection data-id="element-12" data-mp="33orik1hv3xpi" />
          <Bonuses data-id="element-13" data-mp="38m1fe27kzbnd" />
          <Offer data-id="element-14" data-mp="38li6fazwrxlh" />
          <FAQ data-id="element-15" data-mp="38l017ov9q91f" />
        </main>
        <FinalCTA data-id="element-16" data-mp="38o4gbha9up6v" />
        <StickyBuyBar data-id="element-17" data-mp="3dkl42adk71jf" />
        <PurchaseToast data-id="element-18" data-mp="3dl4kfmnk9hvc" />
      </div>
    </CountdownProvider>;
}